<template>
  <div>
     <div class="cdjs_close_btn" @click="clearCode">
       <img src="../../assets/img/icon-white-close.png" alt="">
     </div>
     <Top v-if="state == 0" @changePage="changePage"></Top>
     <Single v-if="state == 1" @toScore="toScore"></Single>
     <Score v-if="state == 2" :resultId="resultId" @changePage="changePage"></Score>
     <Success v-if="state == 3" :resultId="resultId" @closeCD="$emit('openCDJS')"></Success>
     <Ranking v-if="state == 4" @changePage="changePage"></Ranking>
     <toApp  v-if="showTS" @clickClose="$emit('openCDJS')"></toApp>
  </div>
</template>

<script>
  import Top from './children/top.vue'
  import Ranking from './children/ranking.vue'
  import Score from './children/score.vue'
  import Single from './children/single.vue'
  import Success from './children/success.vue'
  import toApp from './children/toApp.vue'
  import {ApiClearCode, ApiGetDepartment} from "../../net/cdjs/index.js"
  import store from '../../vuex/store.js'
  import {getCookie} from '../../untils/common.js'
  export default {
    data: function () {
      return {
        state: 0, //0 top, 1 single, 2 score, 3 success, 4 ranking
        resultId: 0,
        uid: 0,
        showTS: false
      }
    },
    store,
    components: {
      Top,
      Ranking,
      Score,
      Single,
      Success,
      toApp
    },
    methods: {
      changePage: function (num) {
        if (this.showTS) {
          return
        }
        this.state = num
      },
      toScore: function (isSuccess, resultId) {
        this.resultId = resultId
        // console.log('isSuccess', isSuccess)
        if (isSuccess === true) {
          this.state = 3
        } else {
          this.state = 2
        }
      },
      clearCode: function () {
        const pramas = {
          code: this.$store.state.cdCode,
          uid: this.uid
        }
        ApiClearCode(pramas).then(res=>{
          this.$emit('openCDJS')
        }).catch(err=>{
          this.$emit('openCDJS')
        })
      },
      getDepartment: function () {
        ApiGetDepartment({}).then(res=>{
          // console.log('res', res)
          if (res.code == 200) {
            if (!res.value.department) {
              this.showTS = true
            }
          }
        })
      }
    },
    mounted: function () {
      const user = JSON.parse(getCookie('user'))
      this.uid = user.uid
      this.getDepartment()
    }


  }
</script>

<style scoped>
.cdjs_close_btn{
    position: absolute;
    top: 0px;
    right: -40px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.cdjs_close_btn img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/Cdjs.vue